// extracted by mini-css-extract-plugin
export var card = "_4v-0";
export var content = "_4v-1";
export var contentLoading = "_4v-2";